import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'plans-subheader',
  templateUrl: './subheader.component.html',
  styleUrls: ['./subheader.component.css']
})
export class SubheaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
